import type { ITagInputProps } from "./types";

type IEmits = (event: "change", ...args: any[]) => void;

export const isValidInput = (input: String): boolean => {
  const regex = /^[\p{L}\p{N}\s]+$/u;
  return regex.test(input);
};

export function useTagInput(
  props: Required<ITagInputProps>,
  emits: IEmits,
  tagInputDivRef: HTMLElement
) {
  const { t } = useI18n();

  const tags = ref<string[]>([]);
  const tag = ref<string>();
  const addTag = () => {
    if (!tag.value || !tag.value.trim() || tags.value.length >= props.maxLength)
      return;
    if (tags.value.includes(tag.value.trim())) {
      useToast.warning(t("upload.modelTagTips"));
      return;
    }
    tags.value.push(tag.value.trim());
    tag.value = "";
    scrollTagInputDivRef();
  };
  // 推荐标签;
  const addRTag = (item: string) => {
    if (tags.value.length >= props.maxLength || tags.value.includes(item))
      return;
    tags.value.push(item);
  };
  const deleteTag = (item: string) => {
    const index = tags.value.indexOf(item);
    !!~index && tags.value.splice(index, 1);
  };
  // ;
  const initData = () => {
    tags.value = props.initTags;
  };
  onMounted(() => {
    initData();
  });
  // ;
  watch(
    () => props.initTags,
    () => {
      initData();
    }
  );
  watch(
    tags,
    (value) => {
      const emitData = value || [];
      emits("change", emitData);
    },
    {
      deep: true,
    }
  );

  const scrollTagInputDivRef = () => {
    nextTick(() => {
      if (!!tagInputDivRef.value) {
        tagInputDivRef.value.scrollTop = tagInputDivRef.value.scrollHeight;
      }
    });
  };

  const allowedCharsRegex = /[\p{L}\p{N}\s]/gu;

  const handleInput = (value: string) => {
    const filteredChars = value.match(allowedCharsRegex);
    tag.value = filteredChars ? filteredChars.join("") : "";
  };

  return {
    tags,
    tag,
    addTag,
    addRTag,
    deleteTag,
    scrollTagInputDivRef,
    handleInput,
  };
}
